module.exports = __webpack_public_path__ + "media/images/pic/brodno/savvy-ed-10d41c118a751aac4d94662be4ab5e45.png";